import { Button, ButtonRow, Heading, TextArea } from '@ksyos/design-system';
import type { IStepProps } from '../OsasPatientQuestionnaire';
import { translateKey } from '../../../../../translate';
import { useViewportWidth } from '../../../../../utils/hooks/useViewportWidth';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';
import { ScoreInput } from './ScoreInput';

export function Step1(props: IStepProps) {
    const { width } = useViewportWidth();

    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading size="large">Slaaponderzoek</Heading>
                </Stack>

                <ScoreInput
                    error={props.errors.get('explanationClear')}
                    handleChange={(value) => props.handleChange({ explanationClear: value })}
                    question="Vond je de uitleg van de huisarts over het slaaponderzoek duidelijk?"
                    value={props.customControlData.explanationClear}
                />

                <ScoreInput
                    error={props.errors.get('enoughInformation')}
                    handleChange={(value) => props.handleChange({ enoughInformation: value })}
                    question="Kreeg je van Ksyos voldoende informatie over het slaaponderzoek?"
                    value={props.customControlData.enoughInformation}
                />

                <Stack>
                    <StyledFormGroup
                        hasErrors={props.errors.has('sleepExaminationFreeText')}
                        label="Toelichting (optioneel)"
                        layout="vertical"
                    >
                        <TextArea
                            autoResize
                            error={
                                props.errors.get('sleepExaminationFreeText')
                                    ? translateKey('validation.' + props.errors.get('sleepExaminationFreeText'))
                                    : undefined
                            }
                            onChange={(e) => {
                                const sleepExaminationFreeText = e.target.value !== '' ? e.target.value : null;
                                props.handleChange({ sleepExaminationFreeText });
                            }}
                            placeholder="Wil je nog iets kwijt? Vermeld geen persoonlijke gegevens..."
                            value={props.customControlData.sleepExaminationFreeText || ''}
                        />
                    </StyledFormGroup>
                </Stack>

                <ButtonRow justify="right">
                    {width <= 768 && (
                        <Button
                            color="secondary"
                            onClick={props.goToPreviousStep}
                            variant="outline"
                        >
                            Terug
                        </Button>
                    )}
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                    >
                        Ga verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
